import { HttpParams } from '@angular/common/http';
import { SelectedFilters } from 'rio-models';

export function filtersToParams(filters: SelectedFilters): HttpParams {
  let params = new HttpParams();

  if (!filters) {
    return params;
  }

  if (filters.startDate) {
    params = params.set('start_date', filters.startDate);
  }

  if (filters.endDate) {
    params = params.set('end_date', filters.endDate);
  }

  if (filters.categories?.length) {
    filters.categories.forEach(category => {
      params = params.append('category', category);
    });
  }

  return params;
}
